"use client";

import React from "react";
import "./styles.css";
import "../common.css";

export const FeatureBlock = ({
  title,
  children,
  backgroundColor = "#fff",
  borderRadius = 0,
  textColor = "#242323",
  cards = false,
  paddingBottom = false, // Новое свойство
}) => {
  const wrapperClassName = [
    "feature__wrapper",
    borderRadius ? "fix-spacing" : "",
    paddingBottom ? "bottom_padd_none" : "", // Условно добавляем класс
  ]
    .filter(Boolean) // Убираем пустые строки
    .join(" "); // Объединяем классы в строку

  return (
    <div
      className={wrapperClassName}
      style={{
        background: backgroundColor,
        borderRadius: borderRadius,
        marginTop: borderRadius ? borderRadius * -1 : 0,
        marginBottom: borderRadius ? borderRadius * -1 : 0,
        position: borderRadius ? "relative" : "static",
        color: textColor,
      }}
    >
      <div className="container">
        {title && <div className="feature__title">{title}</div>}
        {cards ? <div className="feature__minirow">{children}</div> : children}
      </div>
    </div>
  );
};
